/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable no-constant-condition */
/* eslint-disable padding-line-between-statements */
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-fetching-library';
import { Button, Snackbar, TextField } from '@material-ui/core';

import { useStyles } from './SuccessClip.styles';
import { Loader, Typography } from 'shared/components';
import { useLocale } from 'shared/hooks/useLocale/useLocale';
import { ParticipantSelectionFooter } from 'app/participantSelection/footer/ParticipantSelectionFooter';
import { StudentLoginHeader } from 'app/studentLoginPage/studentLoginHeader/studentLoginHeader';
// import uploadIcon from 'assets/stageClipIcon.svg';
import { renderProgress } from 'api/actions/participantSelection/participantClipping.actions';
import { SuccessClipProps } from './SuccessClip.types';
import { ClipRenderResponse } from 'api/actions/participantSelection/participantClipping.types';
import { MaterialCircularProgress } from './circularProgress/CircularProgress';
import { ReactComponent as Facebook } from 'assets/icons/facebook.svg';
import { ReactComponent as WhatsApp } from 'assets/icons/whatsapp.svg';
import { ReactComponent as LinkedIn } from 'assets/icons/linkedin.svg';
import { ReactComponent as Email } from 'assets/icons/email.svg';
import { ReactComponent as Twitter } from 'assets/icons/x-twitter.svg';
import { ReactComponent as Instagram } from 'assets/icons/insta.svg';
import { ReactComponent as TikTok } from 'assets/icons/tiktok.svg';
// import { ReactComponent as SnapChat } from 'assets/icons/snapchat.svg';
import { ReactComponent as Heart } from 'assets/icons/collctivHeart.svg';
import { ReactComponent as Thump } from 'assets/icons/collctivThumb.svg';
import LinkedInPic from 'assets/linkedinpng.png';

export const SuccessClip = ({ userId, utcTime, eventId, isFromSelfOnBoard, isLinkedInUser }: SuccessClipProps) => {
  const styles = useStyles();
  const { formatMessage } = useLocale();
  const { query } = useQuery(renderProgress(userId, utcTime));
  const [payload, setPayload] = useState<ClipRenderResponse>();
  const [successMessage, setSuccessMessage] = useState<React.ReactNode | null>(null);
  const percentage = payload && payload.progress;

  // const eventId = 'ekowieowie';
  // const isLinkedInUser = true;

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    window.scrollTo(0, 0);

    const fetchData = async () => {
      const { payload: actualPayload, error } = await query();
      if (!error) {
        setPayload(actualPayload);

        if (actualPayload.status === 'success' && intervalId) {
          clearInterval(intervalId);
          intervalId = null; // Optional safety to prevent re-clearing
        }
      }
    };

    fetchData(); // Fetch immediately on mount

    intervalId = setInterval(fetchData, 5000); // Fetch every 5 seconds

    return () => {
      if (intervalId) {
        clearInterval(intervalId); // Cleanup on unmount
      }
    };
  }, [query]);

  useEffect(() => {
    setInterval(() => {
      renderProgress(userId, utcTime);
    }, 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (payload?.status === 'success') {
    const clipUrl = payload.clipSiteUrl;

    window.location.href = clipUrl;
  }

  // eslint-disable-next-line consistent-return
  const getProgressMessage = () => {
    if (percentage) {
      if (percentage >= 80) {
        return 'So close! Your clip is just about ready for you.';
        // eslint-disable-next-line no-else-return
      } else if (percentage >= 50) {
        return `Halfway through—it's looking good! Keep hanging in there. ⏳`;
      } else if (percentage >= 30) {
        return 'Clip is getting warmed up! 🔥';
      } else {
        return 'Hang tight! Your clip is being prepared.';
      }
    } else {
      return 'Feel free to close this page.';
    }
  };

  const handleCopy = () => {
    const url = `${window.location.origin}/register/${eventId}`;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        // You can also show a toast/snackbar here
        setSuccessMessage('Register Link copied');
      })
      .catch(err => {}); // eslint-disable-line @typescript-eslint/no-empty-function
  };

  const handleSnackBarClose = () => {
    setSuccessMessage(null);
  };

  return (
    <>
      {payload?.status === 'success' ? (
        <Loader fullScreen />
      ) : (
        <div>
          <StudentLoginHeader isText />

          {isFromSelfOnBoard ? (
            <>
              <div className={styles.onBoardContainer}>
                {/* Full-width container that holds black bars and content */}
                <div className={styles.onBoard}>
                  {/* Left Black Space */}
                  {/* <div style={{ flex: 1, backgroundColor: 'black' }} /> */}

                  {/* Center White Content Box */}
                  <div className={styles.progressCard1}>
                    <Typography className={styles.rootTextSub1}>All done!</Typography>
                    <Typography className={styles.rootTextSubHeader1}>The magic begins!</Typography>
                    <Typography className={styles.rootTextSub1}>
                      {formatMessage({ id: 'studentSelection.clip.success.header' })}
                    </Typography>

                    {payload?.status !== 'success' && (
                      <>
                        <div className={styles.circularProgressContainer1}>
                          <MaterialCircularProgress value={percentage || 0} thickness={7} />
                        </div>
                        <Typography className={styles.subHeader1}>{getProgressMessage()}</Typography>
                      </>
                    )}
                  </div>

                  {/* Right Black Space */}
                  {/* <div style={{ flex: 1, backgroundColor: 'black' }} /> */}
                </div>
                <div className={styles.onBoardCopyContainer}>
                  <div className={styles.onBoardCopyCard}>
                    <Typography className={styles.heroText}>
                      Be a Hero{' '}
                      <span role="img" aria-label="muscle">
                        💪
                      </span>
                    </Typography>
                    <Typography className={styles.heroText}>Let your friends get their clips too!</Typography>
                    <Typography>Share link</Typography>

                    <div style={{ display: 'flex', width: '100%', gap: '0.5rem', marginTop: '0.2rem' }}>
                      <TextField
                        variant="outlined"
                        size="small"
                        value={`${window.location.origin}/register/${eventId}`}
                        fullWidth
                        disabled
                      />
                      <Button
                        onClick={() => handleCopy()}
                        size="small"
                        style={{ backgroundColor: '#18a957', color: 'white' }}
                        variant="contained"
                      >
                        Copy
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.onBoardCopyContainerMobile}>
                <div className={styles.onBoardCopyCard}>
                  <Typography className={styles.heroText}>
                    Be a Hero
                    <span role="img" aria-label="muscle">
                      💪
                    </span>
                  </Typography>
                  <Typography className={styles.heroText}>Let your friends get their clips too!</Typography>
                  <Typography>Share link</Typography>

                  <div style={{ display: 'flex', width: '100%', gap: '0.5rem', marginTop: '0.5rem' }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      value={`${window.location.origin}/register/${eventId}`}
                      fullWidth
                    />
                    <Button
                      size="small"
                      onClick={() => handleCopy()}
                      style={{ backgroundColor: '#18a957', color: 'white' }}
                      variant="contained"
                    >
                      Copy
                    </Button>
                  </div>
                </div>
              </div>
              {/* social icons */}
              {/* social icons */}
              <div className={styles.onBoardSocialContainer}>
                <div className={styles.onBoardSocialThump}>
                  <Thump />
                  <Heart />
                </div>
                <div className={styles.onBoardSocial}>
                  <Facebook />
                  <LinkedIn />
                  <WhatsApp />
                  <Email />
                  <TikTok />
                  {/* <SnapChat /> */}
                  <Instagram />
                  <Twitter />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={styles.container}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                >
                  {/* <Image src={uploadIcon} alt="404" className={styles.image} /> */}
                  <Typography className={styles.rootTextSub}>All done!</Typography>
                  <Typography className={styles.rootTextSubHeader}>The magic begins!</Typography>

                  <Typography className={styles.rootTextSub}>
                    {formatMessage({ id: 'studentSelection.clip.success.header' })}
                  </Typography>
                </div>
                {isLinkedInUser && (
                  <>
                    <span className={styles.linkedinContent}>
                      <span className={styles.linkedinIcon}>
                        <img src={LinkedInPic} width={25} alt="linkedin" />
                      </span>
                      <span className={styles.linkedinText}>Signed up with LinkedIn?</span>
                    </span>
                    <Typography className={styles.linkedInsubHeader}>
                      Your clip will appear in your feed, boosting your professional profile!
                    </Typography>
                  </>
                )}

                {payload?.status !== 'success' && (
                  <>
                    <div className={styles.circularProgressContainer}>
                      <MaterialCircularProgress value={percentage || 0} thickness={7} />
                    </div>
                    <Typography className={styles.subHeader}>{getProgressMessage()}</Typography>
                  </>
                )}

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <>
                    {payload?.status !== 'success' && (
                      <Typography className={styles.rootText}>
                        {formatMessage({ id: 'studentSelection.clip.success.sub_header' })}
                      </Typography>
                    )}
                    {/* <Typography className={styles.subHeader}>
                  {formatMessage({ id: 'studentSelection.clip.success.sub_header' })}
                </Typography> */}
                  </>
                </div>
              </div>
            </>
          )}
          <ParticipantSelectionFooter />
        </div>
      )}

      <Snackbar
        open={!!successMessage}
        onClose={handleSnackBarClose}
        message={successMessage}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        className={styles.snackBar}
        autoHideDuration={10000}
      />
    </>
  );
};
